import { useParams } from 'react-router-dom';
import { dummyArticles } from './Home';
import ArticleWithKeywords from '../components/ArticleWithKeywords';

// Justin is adding a random commit and pushing it so that he can deploy this to vercel
// thanks Anish

function ArticlePage() {
  const { id } = useParams();
  console.log('ArticlePage - ID from URL:', id);
  
  const article = dummyArticles.find(article => article.id === id);
  console.log('ArticlePage - Found article:', article);

  if (!article) {
    return (
      <div style={{ 
        marginLeft: '30px',
        textAlign: 'center', 
        padding: '60px 20px',
        color: '#666'
      }}>
        <h2>Article not found</h2>
        <p>The article you're looking for doesn't exist. ID: {id}</p>
      </div>
    );
  }

  return <ArticleWithKeywords article={article} />;
}

export default ArticlePage;
